import React, { useEffect, useState } from "react";
import "./css/index.css";
import { useLocation } from "react-router-dom";
import { officeApi } from "../../api/config";
import CouponUserList from "../../components/CouponUserList/CouponUserList";
import { CouponUserState } from "../../interface/interface";

type LocationType = {
  state: string;
};

const CouponList = () => {
  const { state } = useLocation();
  const [data, setData] = useState<CouponUserState[]>([]);
  useEffect(() => {
    officeApi
      .get(`/cstm/cpon_usr?cpon_id=${state}`)
      .then(({ data: { sts_fg, succ_obj } }) => {
        if (sts_fg) {
          setData(succ_obj);
        }
      });

    return () => {};
  }, [state]);

  return (
    <main className="coupon-list-page">
      <div className="wrapper">
        <div className="title">발급 대상</div>
        <CouponUserList ListData={data} SpliceUser={undefined} />
      </div>
    </main>
  );
};

export default CouponList;
